import { useAuth } from "../modules/auth";
import { useState, useEffect } from 'react';

function useCheckPermission(permissionVal) {
  const { currentUser } = useAuth();
  const [permission, setPermission] = useState({
    isViewable: false,
    isCreatable: false,
    isEditable: false,
    isDeletable: false,
  });

  useEffect(() => {
    const localStorageValue = JSON.parse(window.localStorage.getItem('permission'));

    // console.log("Permission value:", localStorageValue);

    if (localStorageValue?.length > 0) {
      const permissions = localStorageValue
        .filter((val) => val?.module?.toLowerCase() === permissionVal.toLowerCase())
        .map((val) => val.type.toLowerCase());

      setPermission({
        isViewable: permissions.includes('view'),
        isCreatable: permissions.includes('create'),
        isEditable: permissions.includes('edit'),
        isDeletable: permissions.includes('delete'),
      });
    } 
    else 
    setPermission({
      isViewable: false,
      isCreatable: false,
      isEditable: false,
      isDeletable: false,
    });
    if (currentUser?.userType === 'SUPERADMIN') {
      setPermission({
        isViewable: true,
        isCreatable: true,
        isEditable: true,
        isDeletable: true,
      });
    }
  }, [permissionVal, currentUser]);


  return permission;
}

export default useCheckPermission;

export function usePermissionValues() {
  const permissionVideos = useCheckPermission("Videos");
  const permissionSeries = useCheckPermission("Series");
  const permissionSeasons = useCheckPermission("Seasons");
  const permissionEpisodes = useCheckPermission("Episodes");
  const permissionLiveTV = useCheckPermission("Live TV");
  const permissionEPG = useCheckPermission("EPG");
  const permissionLibrary = useCheckPermission("Library");
  const permissionEncoding = useCheckPermission("Encoding");
  const permissionEncodingserver = useCheckPermission("Encoding Server");
  const permissionVideoLayout = useCheckPermission("Layouts");
  const permissionLiveStream = useCheckPermission("Live Stream");
  const permissionLibraryViewURL = useCheckPermission("Library View URL");
  const permissionVariants = useCheckPermission("Variants");


  const permissionAlbums = useCheckPermission("Albums");
  const permissionPodcasts = useCheckPermission("Podcasts");
  const permissionPlayist = useCheckPermission("Playlist");
  const permissionAudioGenres = useCheckPermission("Audio Genres");
  const permissionAudioLayout = useCheckPermission("Audio Layouts");

  const permissionCustomerAnalystics = useCheckPermission("Customer Analytics");
  const permissionContentAnalystics = useCheckPermission("Content Analytics");
  const permissionAudioAnalystics = useCheckPermission("Audio Analytics");
  const permissionAudioAlbumAnalystics = useCheckPermission("Album Analytics");
  const permissionAudioTrackAnalystics = useCheckPermission("Track Analytics");
  const permissionAudioPlaylistAnalystics = useCheckPermission("Playlist Analytics");
  const permissionDeviceAnalystics = useCheckPermission("Device Analytics");
  const permissionGeoLocationAnalystics = useCheckPermission("Geo Location Analytics");
  const permissionRealTimeAnalystics = useCheckPermission("Real Time Analytics");
  const permissionRevenueAnalystics = useCheckPermission("Revenue Analytics");
  const permissionContentPartnerAnalystics = useCheckPermission("Content Partner Analytics");
  const permissionMonitorAnalystics = useCheckPermission("Grafana Dashboard");
  const permissionAdAnalystics = useCheckPermission("Ad Analytics");
  const permissionB2BAnalystics = useCheckPermission("B2B Analytics");
  const permissionReportAnalytics = useCheckPermission("Reports Analytics")
  const permissionOverallSummaryAnalytics = useCheckPermission("Overall Summary Analytics")
  const permissionContentWiseSummaryAnalytics = useCheckPermission("Content Wise Overall Analytics")
  const permissionUserWiseSummaryAnalytics = useCheckPermission("User Trends Overall Analytics")
  const permissionPlanWiseStreamAnalystics = useCheckPermission("Plan Wise Stream Analytics");



  const permissionCategories = useCheckPermission("Categories");
  const permissionLanguage = useCheckPermission("Language");
  const permissionGenres = useCheckPermission("Genres");
  const permissionProdHouse = useCheckPermission("Prod House");
  const permissionCasts = useCheckPermission("Casts");
  const permissionGeoRestriction = useCheckPermission("Geo Restrictions");
  const permissionSpecialTag = useCheckPermission("Special Tag");
  const permissionCBFC = useCheckPermission("Age Rating");
  const permissionEpisodeType = useCheckPermission("Episode Type");
  const permissionOTTGuide = useCheckPermission("OTT Guidelines");
  const permissionLabel = useCheckPermission("Label");


  const permissionBroadcastGroups = useCheckPermission("Broadcast Groups");
  const permissionBroadcastMessages = useCheckPermission("Broadcast Messages");

  const permissionPlans = useCheckPermission("Plans");
  const permissionPlanGroups = useCheckPermission("Plan Groups");
  const permissionTransaction = useCheckPermission("Transaction");
  const permissionDownloadInvoice = useCheckPermission("Download Invoice");
  const permissionParkingPlan = useCheckPermission("Parking Plan");
  const permissionValidateTransaction = useCheckPermission("Validate Transaction");
  const permissionSubscription = useCheckPermission("Subscription");
  const permissionRental = useCheckPermission("Rental");
  const permissionPaymentGateway = useCheckPermission("Payment Gateway");
  const permissionCoupon = useCheckPermission("Coupon");
  const permissionReferral = useCheckPermission("Referral Partner");
  const permissionMonetizationProfile = useCheckPermission("Monetization Profiles");
  const permissionAdProfile = useCheckPermission("Ad Profiles")
  const permissionRevenuePartner = useCheckPermission("Revenue Partner")
  const permissionWalletHistory = useCheckPermission("Revenue Partner Wallet History")
  const permissionRevenuePartnerSubscription = useCheckPermission("Revenue Partner History")
  const permissionCoinsHistory = useCheckPermission("Coin History")
  const permissionCoinsTransactions = useCheckPermission("Coin Transactions")

  const permissionAds = useCheckPermission("Manage Ads");
  const permissionAdCampaign = useCheckPermission("Ad Campaign");
  const permissionAppLauncher = useCheckPermission("Ad Popup");
  const permissionPopupContents = useCheckPermission("Profile List Ads");
  const permissionContentUpNext = useCheckPermission("Content Upnext Rule");


  const permissionUserManagement = useCheckPermission("User Management");
  const permissionupdateUserplan = useCheckPermission("Activate Plan");
  const permissionupdateUserdetails = useCheckPermission("User Details");
  const permissionDeactivate = useCheckPermission("Deactivate Account");
  const permissionStaticOTP = useCheckPermission("Static OTP");
  const permissionUpdateTransaction = useCheckPermission("Update Transaction");
  const permissionContentPartner = useCheckPermission("Content Partner");
  const permissionAdminUsers = useCheckPermission("Admin Users");
  const permissionRoles = useCheckPermission("Roles");

  const permissionFeedbacks = useCheckPermission("Feedbacks");
  const permissionStorageSettings = useCheckPermission("Storage Settings");
  const permissionEPGLibrary = useCheckPermission("EPG Library");
  const permissionCDNManagement = useCheckPermission("CDN Management");

  const permissionDashboard = useCheckPermission("Dashboard");

  const permissionGeoFencing = useCheckPermission("Geo Fencing");


  const permissionSocialLinks = useCheckPermission("Social Links");

  const permissionImageConfig = useCheckPermission("Image Config");
  const permissionAdSettings = useCheckPermission("Ad Settings");
  const permissionEmailTemplate = useCheckPermission("Email Templates");
  const permissionSMSTemplate = useCheckPermission("SMS Templates");
  const permissionStaticWebPages = useCheckPermission("Static Web Pages");


  const permissionDevicePlaybackConfig = useCheckPermission("Device Config");
  const permissionActivityTracker = useCheckPermission("Activity Tracker");



  return {
    permissionVideos, permissionSeries, permissionSeasons, permissionEpisodes, 
    permissionLiveTV, permissionLibrary, permissionEncoding, permissionVideoLayout, permissionEPG, permissionLiveStream,

    permissionAlbums, permissionPodcasts, permissionPlayist, permissionAudioGenres, permissionAudioLayout,

    permissionCategories, permissionLanguage, permissionGenres, permissionProdHouse, 
    permissionCasts, permissionGeoRestriction, permissionContentPartner,
    permissionSpecialTag, permissionCBFC, permissionEpisodeType, permissionOTTGuide, permissionLabel,

    permissionCustomerAnalystics, permissionContentAnalystics, permissionB2BAnalystics,
    permissionAudioAnalystics, permissionAudioAlbumAnalystics, permissionAudioTrackAnalystics, permissionAudioPlaylistAnalystics,
    permissionDeviceAnalystics, permissionGeoLocationAnalystics, permissionRealTimeAnalystics, 
    permissionRevenueAnalystics, permissionContentPartnerAnalystics, permissionMonitorAnalystics, 
    permissionAdAnalystics, permissionReportAnalytics, permissionOverallSummaryAnalytics, 
    permissionContentWiseSummaryAnalytics, permissionUserWiseSummaryAnalytics, permissionPlanWiseStreamAnalystics,

    permissionPlans, permissionTransaction,  permissionPlanGroups,
    permissionSubscription, permissionRental, permissionAppLauncher,
    permissionPaymentGateway, permissionCoupon, permissionReferral, 
    permissionMonetizationProfile, permissionAdProfile, permissionRevenuePartner, permissionWalletHistory, permissionRevenuePartnerSubscription,
    permissionCoinsHistory, permissionCoinsTransactions,

    permissionAds, permissionAdCampaign,
    
    permissionDashboard, permissionGeoFencing, permissionUserManagement, 
    permissionStorageSettings, permissionEPGLibrary, permissionDevicePlaybackConfig, permissionCDNManagement,
    
    permissionAdminUsers, permissionRoles, permissionBroadcastGroups, permissionBroadcastMessages, permissionSMSTemplate,
    permissionFeedbacks, permissionSocialLinks, permissionImageConfig, permissionAdSettings, permissionEmailTemplate, permissionStaticWebPages, permissionPopupContents, permissionContentUpNext,
    permissionupdateUserplan, permissionupdateUserdetails, permissionDeactivate, permissionActivityTracker, permissionDownloadInvoice,

    permissionVariants, permissionLibraryViewURL, permissionParkingPlan, permissionValidateTransaction, permissionStaticOTP, permissionEncodingserver, permissionUpdateTransaction
  };
}

